import { useRef } from "react";
import { useScroll, useTransform, useReducedMotion } from "framer-motion";

// Ties opacity/offset directly to scroll progress instead of toggling on an
// IntersectionObserver "in view" event. whileInView-style reveals can miss
// their trigger during fast or Lenis-smoothed scrolling, which reads as the
// animation "sometimes" not firing; a continuous scroll-linked value can't
// be missed since it's recomputed from the actual scroll position every frame.
export function useScrollReveal({ delay = 0, distance = 40, axis = "y", fromRight = false } = {}) {
  const ref = useRef(null);
  const prefersReducedMotion = useReducedMotion();
  const shift = Math.min(delay * 100, 30);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: [`start ${95 - shift}%`, `start ${55 - shift}%`],
  });
  const opacity = useTransform(scrollYProgress, [0, 1], [0, 1]);
  const start = axis === "x" ? (fromRight ? distance : -distance) : distance;
  const offset = useTransform(scrollYProgress, [0, 1], [start, 0]);

  if (prefersReducedMotion) {
    return { ref, opacity: 1, offset: 0 };
  }
  return { ref, opacity, offset };
}
